@if (content()) {
  <div dir="auto" class="w-full leading-normal">
    <div
      #contentContainer
      class="rich-text-content overflow-hidden break-words transition-[max-height] duration-[400ms] ease-[cubic-bezier(0.4,0,0.2,1)]"
      [class.collapsed]="isCollapsed()"
      [class.expanded]="!isCollapsed()"
      [style.max-height]="
        isCollapsed() ? collapsedHeight() : fullContentHeight()
      "
      [innerHTML]="isHtml() ? sanitizedContent() : content()"></div>

    @if (needsTruncation()) {
      <div class="flex items-center gap-sm mt-sm">
        <button
          type="button"
          class="text-primary-600 text-xs font-medium cursor-pointer border-none bg-transparent p-0 flex items-center gap-x-sm"
          (click)="toggle()">
          {{
            isCollapsed()
              ? (seeMoreLabel() | transloco)
              : (seeLessLabel() | transloco)
          }}

          <lib-chevron-down-icon
            iconClass="size-5 text-primary-600 transition duration-300"
            [class.rotate-180]="!isCollapsed()" />
        </button>
      </div>
    }
  </div>
} @else {
  @if (isHtml()) {
    <lib-table-empty-state
      [noDataTitle]="'table_no_data_title' | transloco"
      [noDataDescription]="'section_no_data_description' | transloco" />
  } @else {
    <div class="view-mode-value text-neutral-900 mt-x-sm">
      {{ 'details_not_found_label' | transloco }}
    </div>
  }
}
